import Vue from 'vue'

import dotenv from 'dotenv'
dotenv.config()

import App from './App.vue'

import router from './router'
import store from './store/store'
import './registerServiceWorker'
import axios from 'axios'
import Notifications from 'vue-notification'
import './assets/main.scss'
import { prettifyErrorMessage } from './utils'

import 'flatpickr/dist/flatpickr.css'
import VueflatPickr from 'vue-flatpickr-component'

import moment from 'moment'
import 'moment/locale/id'

import numeral from 'numeral'

Vue.use(VueflatPickr)
Vue.use(Notifications)
Vue.config.productionTip = false
Vue.prototype.moment = moment
Vue.prototype.numeral = numeral

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
